import React from 'react';

const ExportCheckbox = ({ 
  sectionId, 
  handleSectionExport, 
  markAllCheckboxes,
  style = {}
}) => {
  return (
    <label 
      style={{
        display: 'flex', 
        alignItems: 'center', 
        position: 'relative', 
        fontStyle: 'italic', 
        color: '#526666',
        ...style
      }}
    >
      <span
        onClick={() => handleSectionExport(sectionId)}
        style={{
          display: 'inline-block',
          width: '16px',
          height: '16px',
          marginRight: '8px',
          border: '2px solid #526666',
          borderRadius: '4px',
          backgroundColor: markAllCheckboxes.has(sectionId)
            ? '#526666'
            : 'transparent',
          cursor: 'pointer',
          position: 'relative',
          padding: '0 2px'
        }}
        id={sectionId}
      >
        {markAllCheckboxes.has(sectionId) && (
          <span
            style={{
              position: 'absolute',
              top: '-8px',
              left: '0px',
              fontSize: '24px',
              color: 'white',
              padding: '0 0 0 2px',
              margin: '0'
            }}
          >
            ✔
          </span>
        )}
      </span>
      Mark Section For Export
    </label>
  );
};

export default ExportCheckbox;
